import request from '@/utils/request'

// 查询【客户联系人】列表
export function listIndustry(query) {
  return request({
    url: '/qqad/industry/list',
    method: 'get',
    params: query
  })
}

// 查询【客户联系人】详细
export function getIndustry(systemIndustryId) {
  return request({
    url: '/qqad/industry/' + systemIndustryId,
    method: 'get'
  })
}

// 新增【客户联系人】
export function addIndustry(data) {
  return request({
    url: '/qqad/industry',
    method: 'post',
    data: data
  })
}

// 修改【客户联系人】
export function updateIndustry(data) {
  return request({
    url: '/qqad/industry',
    method: 'put',
    data: data
  })
}

// 删除【客户联系人】
export function delIndustry(systemIndustryId) {
  return request({
    url: '/qqad/industry/' + systemIndustryId,
    method: 'delete'
  })
}

// 导出【客户联系人】
export function exportIndustry(query) {
  return request({
    url: '/qqad/industry/export',
    method: 'get',
    params: query
  })
}

//获取行业前2级
export function getTwoLevelIndustryList() {
  return request({
    url: '/qqad/industry/selectTwoLevelIndustryList',
    method: 'get'
  })
}